import React from 'react';
import './Button.css'; // Import the CSS file where the button styles are defined

const Button = ({ id, label, onClick, type = 'button', style = {}, disabled = false }) => {
    return (
        <button
            id={id}
            className="btn-contact-us"
            onClick={onClick}
            type={type}
            style={style}
            disabled={disabled}
        >
            {label}
        </button>
    );
};

export default Button;
